module.exports = __webpack_public_path__ + "img/atari1200_page8.95b50541.jpg";